import { useMutation } from '@tanstack/react-query'
import { UpdateResult } from '../types/types'
import { components } from '../types/prove-v2'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'

interface UpdateResultMutationVariables {
  requisitionId: number
  resultId: number
  etag: string
  body: UpdateResult
}

export const useUpdateResultMutation = () => {
  const { authFetchV3 } = useAuth()
  return useMutation({
    mutationFn: async ({
      requisitionId,
      resultId,
      etag,
      body
    }: UpdateResultMutationVariables) => {
      const { data, error } = await authFetchV3().PUT(
        '/requisitions/{requisitionId}/results/{resultId}',
        {
          headers: {
            'Content-Type': 'application/vnd.mattilsynet.proveta.v3+json'
          },
          params: {
            header: { 'If-Match': etag },
            path: {
              requisitionId,
              resultId
            }
          },
          body
        }
      )
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}

interface CreateResultsV2MutationVariables {
  requisitionId: number
  body: components['schemas']['CreateResultsV2']
}

export const useCreateResultsMutation = () => {
  const { authFetchV2 } = useAuth()
  return useMutation({
    mutationFn: async ({
      requisitionId,
      body
    }: CreateResultsV2MutationVariables) => {
      const { data, error } = await authFetchV2().POST(
        '/requisitions/{requisitionId}/results',
        {
          params: {
            path: {
              requisitionId
            }
          },
          headers: {
            Accept: 'application/vnd.mattilsynet.proveta.v3+json'
          },
          body
        }
      )
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}
